//export const BASE_API = "http://localhost:3002";
//export const BASE_API = "/api";
export const BASE_API = "api";